import { useEffect, useState, useCallback } from "react";
import { restApiBase } from "../settings";
import { Link, useLocation } from "react-router-dom";
import { Spinner, Tooltip, OverlayTrigger } from "react-bootstrap";

export function ReportHistory({ token, userId }) {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const location = useLocation();
    const match = location.pathname.match(/\/report\/detail\/([^/]+)/);
    const currentReportId = match ? match[1] : null;

    const fetchReports = useCallback(async () => {
        if (!token || !userId) return;

        setLoading(true);
        setError(null);

        console.log("getting user %s report from %s", userId, restApiBase)

        try {
            const response = await fetch(
                `${restApiBase}user_reports?user_id=${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error(`HTTP error ${response.status}`);

            const data = await response.json();
            setReports(data.reports || []);


            const reportsMap = data.reports.reduce((acc, report) => {
                acc[report.report_id] = report;
                return acc;
            }, {});

            localStorage.setItem("reportHistory", JSON.stringify(reportsMap));

            console.dir(data.reports);

        } catch (err) {
            console.error(err);
            setError("Ошибка при загрузке отчетов.");
        } finally {
            setLoading(false);
        }
    }, [token, userId]);

    // первый рендер и при изменении URL
    useEffect(() => {
        fetchReports();
    }, [fetchReports, location.pathname]);

    // авто-обновление каждые 5 секунд, если есть не COMPLETED отчеты
    useEffect(() => {
        const hasPending = reports.some(
            (r) => r.report_state.toLowerCase() !== "completed"
        );

        if (!hasPending) return; // все завершены, интервал не нужен

        const interval = setInterval(() => {
            fetchReports();
        }, 5000);

        return () => clearInterval(interval); // очистка при размонтировании
    }, [reports, fetchReports]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "Unknown date";
        const date = new Date(dateStr);

        const options = {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        };

        return date.toLocaleString("en-US", options);
    };

    if (reports.length === 0 && loading) {
        return (
            <div className="report-history">
                <div className="d-flex align-items-center p-4">
                    <Spinner animation="grow" role="status" className="me-2">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <span>Loading history...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="report-history">
            <ul className="list-group">
                {reports.map((report) => {
                    const metadata = report.report_metadata || {};
                    const options = metadata.options || {};
                    const params = metadata.parameters || {};

                    const tooltip = (
                        <Tooltip
                            id={`tooltip-${report.report_id}`}
                            className="tooltip-wide"
                        >
                            {params.target && (
                                <div>
                                    <strong>Target:</strong> {params.target}
                                </div>
                            )}
                            {params.scope?.length > 0 && (
                                <div>
                                    <strong>Scope:</strong> {params.scope.join(", ")}
                                </div>
                            )}
                            {options.risk_factors?.length > 0 && (
                                <div>
                                    <strong>Risk Factors:</strong>{" "}
                                    {options.risk_factors.join(", ")}
                                </div>
                            )}
                        </Tooltip>
                    );

                    return (
                        <OverlayTrigger
                            key={report.report_id}
                            placement="right"
                            overlay={tooltip}
                            delay={{ show: 250, hide: 200 }}
                        >
                            <Link
                                to={
                                    report.report_state.toLowerCase() === "completed"
                                        ? `/report/detail/${report.report_id}`
                                        : `/report/run/${report.report_id}`
                                }
                                className={`list-group-item ${
                                    report.report_id === currentReportId ? "active" : ""
                                }`}
                            >
                                <span
                                    className={
                                        "report-state " + report.report_state.toLowerCase()
                                    }
                                >
                                    {report.report_state}
                                </span>
                                <>
                                    {report.report_title || "Untitled"} <br />
                                    {formatDate(report.created_at)}
                                </>
                            </Link>
                        </OverlayTrigger>
                    );
                })}
            </ul>
        </div>
    );
}
